<template>
  <div> 
    <base-crud
      :ref="table"
      :crudName="crudName"
      :newText="newText"
      :table="table"
      :columns="columns"
      :options="options"
      :endPoint="endPoint"
      :enableAdd="true"
      :enableEdit="true"
      :enableDelete="true"
      :enableView="false"
      :dataForm="dataForm"
      @fieldUpdated="fieldUpdated"
    ></base-crud>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";
export default {
  data() {
    return {
      error: "",
      crudName: "Grupos de Visualização",
      newText: "Cadastrar Grupo",
      table: "viewingGroupsTable",
      columns: [
        "id",
        "name",
        "actions"
      ],
      tableData: [
        "id",
        "name",
        "actions"
      ],
      options: {
        sortIcon: {
            base : 'space_fas fas',
            is: 'fa-sort',
            up: 'fa-sort-amount-up',
            down: 'fa-sort-amount-down'
        },
        filterByColumn: true,
        debounce: 1000,
        sortable: [
          "id",
          "name"
        ],
        filterable: ["id", "name"],
        sortable: ["id", 'name'],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          name: "Título",
          actions: "Ações"
        },
        
        requestFunction: function(data) {
          let requestData = {};

          let query = this.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [];

          return this.$http.get(this.url + "?" + query, requestData).catch(
            function(e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        }
      },
      endPoint: "signature_viewing_groups/",
      dataForm: {
        title: {
          add: "Novo Grupo de Visualização",
          edit: "Editar Grupo",
          view: "Visualizar Grupo",
          icon: "fa fa-pen"
        },
        button: {
          back: "/signature_viewing_groups"
        },
        url: {
          model: "signature_viewing_groups"
        },
        messages: {
          success: {
            add: "Grupo cadastrado com sucesso!",
            edit: "Grupo alterado com sucesso!"
          }
        },
        fields: [
          {
            name: "name",
            model: "name",
            label: "Título",
            type: "text",
            isRequired: {
              add: true,
              edit: true
            },
            placeholder: "",
            class: "",
            length: "12|6|6",
            offset: null
          },
        ]
      }
    };
  },
  methods: {
    
    fieldUpdated: function(field) {
      const self = this;
      if (field.model == "company_id") {
        let filters = "&company_id=" + field.value;
        self.getBranches(filters);
      } else if (field.model == "branch_id") {
        let filters = "&branch_id=" + field.value;
        self.getSectors(filters);
      } else if (field.model == "sector_id") {
        let filters = "&sector_id=" + field.value;
        self.getRoles(filters);
      }
    },
    query: function(query) {
      let columns = {
        id: "id",
        name: "name",
        
      };
      let filters = "orderByDesc=name&";
      $.each(query, function(index, value) {
        filters += columns[index] + "=" + value + "&";
      });

      return filters;
    },
    getCompanies: function(filters) {
      const self = this;
      const api =
        self.$store.state.api +
        "companies?paginated=false" +
        (filters ? filters : "");
      self.$http
        .get(api)
        .then(response => {
          let found = self.dataForm.fields.find(x => x.name == "company_id");
          if (found) {
            found.list = response.data.data;
          }
        })
        .catch(error => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getBranches: function(filters) {
      const self = this;
      const api =
        self.$store.state.api +
        "branches?paginated=false" +
        (filters ? filters : "");
      self.$http
        .get(api)
        .then(response => {
          let found = self.dataForm.fields.find(x => x.name == "branch_id");
          if (found) {
            found.list = response.data.data;
          }
        })
        .catch(error => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getSectors: function(filters) {
      const self = this;
      const api =
        self.$store.state.api +
        "sectors?paginated=false" +
        (filters ? filters : "");
      self.$http
        .get(api)
        .then(response => {
          let found = self.dataForm.fields.find(x => x.name == "sector_id");
          if (found) {
            found.list = response.data.data;
          }
        })
        .catch(error => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getRoles: function(filters) {
      const self = this;
      const api =
        self.$store.state.api +
        "roles?paginated=false" +
        (filters ? filters : "");
      self.$http
        .get(api)
        .then(response => {
          let found = self.dataForm.fields.find(x => x.name == "role_id");
          if (found) {
            found.list = response.data.data;
          }
        })
        .catch(error => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getUserTypes: function() {
      const self = this;
      const api = self.$store.state.api + "usertypes?paginated=false";
      self.$http
        .get(api)
        .then(response => {
          let found = self.dataForm.fields.find(x => x.name == "type_id");
          if (found) {
            found.list = response.data.data.filter(x => x.id != 4);
          }
        })
        .catch(error => {
          self.$message("Erro", error.response.data, "error");
        });
    }
  },
  mounted() {
    const self = this;
    self.getCompanies();
    self.getBranches();
    self.getSectors();
    self.getRoles();
    self.getUserTypes();
  },
  components: {
    BaseCrud
  }
};
</script>


// WEBPACK FOOTER //
// src/components/ViewingGroups/Crud.vue